import { GameState, Investigator } from '../api';

export const findInvestigator = (
  state: GameState,
  name?: string
): Investigator | undefined => {
  if (!name) return undefined;
  return state.investigatorsByName?.[name] ??
    Object.values(state.investigatorsByName ?? {}).find(
      investigator => investigator.name?.toLowerCase() === name.toLowerCase()
    );
};

export const getFirstControlledInvestigator = (
  state: GameState,
  playerName: string
): Investigator | undefined => {
  const names = state.players?.find(
    player => player.name.toLowerCase() === playerName.toLowerCase()
  )?.controlledInvestigators ?? [];
  for (const name of names) {
    const investigator = findInvestigator(state, name);
    if (investigator) return investigator;
  }
  return undefined;
};
